import React from "react";
import { ORGANIZATION_TASK_TEMPLATE_FILTER_MAX_IDS } from "@common/schemas/organization-task-template.schema";
import { useOrganizationTaskGroups } from "@api/organizationTaskGroup.api";
import { BaseFilterProps } from "../../lib";
import { SearchableIdListFilter } from "../SearchableIdListFilter/SearchableIdListFilter";

export const OrgTaskTemplateGroupFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: taskGroups = [] } = useOrganizationTaskGroups();

    return (
        <SearchableIdListFilter
            items={taskGroups}
            selectedIds={filters.orgTaskTemplateGroupIds}
            onChange={(groupIds) =>
                onChange({
                    orgTaskTemplateGroupIds: groupIds?.slice(
                        0,
                        ORGANIZATION_TASK_TEMPLATE_FILTER_MAX_IDS,
                    ),
                })
            }
            name="orgTaskTemplateGroup"
        />
    );
};
